import { CellProps } from 'react-table';
import { DropdownMenu, Icon } from 'legacy-components/componets';
import { DropdownMenuItem } from 'legacy-components/dropdown-menu/common/types/dropdown-menu-item';
import Dropdown from 'rc-dropdown';
import { ToursScheduleTableActionsCellType, ToursScheduleTableRowType } from '../types';
import { AuthRole, TourStatusDto } from 'common/enums/enums';
import { EstateStatusDto } from 'common/enums/services/api/estates/estate-status-dto.enum';
import { useHasRoles } from 'hooks';
import { useUnverifiedProfileActionGuard } from 'hooks/use-unverified-profile-guard';
import { useListingCompletenessGuard } from 'hooks/use-listing-completeness-guard';
import useTourListingStatus from 'hooks/query/tours/use-tour-listing-status';

export const LandlordToursActionsMenuCell = ({
  row,
}: CellProps<ToursScheduleTableRowType, ToursScheduleTableActionsCellType>) => {
  const { actions } = row.original;
  const { onCancel, onView, tourStatus: status, onViewDocuments, onConfirm, isConfirmed, listing, id } = actions;
  const isLandlord = useHasRoles([AuthRole.Landlord]);

  const { data: listingStatus, isLoading: isListingStatusLoading } = useTourListingStatus(id);
  
  const { withActionGuard } = useUnverifiedProfileActionGuard({
    modalProps: {
      actionText: 'to perform this action',
      onClose: () => {}
    }
  });

  const { withListingCompletenessGuard, isListingComplete } = useListingCompletenessGuard(
    listingStatus ?? undefined, 
    {
      modalProps: {
        onClose: () => {}
      }
    }
  );
  
  const isComplete = isListingStatusLoading ? false : (listingStatus ? isListingComplete : true);

  const menuItems: DropdownMenuItem[] = [
    {
      id: 1,
      title: 'Confirm Tour',
      onClick: () => {
        withActionGuard(() => withListingCompletenessGuard(() => {
          onConfirm?.();
        }));
      },
      icon: 'check',
      visible: status === TourStatusDto?.Scheduled && !isConfirmed,
      disabled: status === TourStatusDto?.Scheduled && (!isComplete || isListingStatusLoading),
      tooltip: isListingStatusLoading 
        ? 'Checking listing status...' 
        : !isComplete 
          ? 'Please complete your listing details before confirming the tour' 
          : undefined,
    },
    {
      id: 2,
      title: 'View details',
      onClick: () => onView?.(),
      icon: 'faEye',
      visible: true,
    },
    // {
    //   id: 3,
    //   title: `View renter's documents`,
    //   onClick: () => onViewDocuments?.(),
    //   icon: 'files',
    //   visible: true,
    // },
    // NOTE: HIDE OPTION ( AX-738 )
    // {
    //   id: 3,
    //   title: 'Cancel',
    //   onClick: () => onCancel?.(),
    //   icon: 'shape',
    //   visible: isLandlord && (status === TourStatusDto?.Scheduled || status === TourStatusDto?.Reserved),
    // },
  ].filter((o) => o.visible) as DropdownMenuItem[];

  return (
    <Dropdown trigger={['click']} overlay={<DropdownMenu menuItems={menuItems} headerTitle={'Actions'} />}>
      <Icon name={'dots-menu'} onClick={() => { }} />
    </Dropdown>
  );
};
